/**
 * Privacy consent UI text colors
 *
 * The catalog `privacy-consent` block portals its banner and preferences
 * panel to document.body, so section-scoped design overrides never reach
 * them. Remap text tokens to white so copy stays readable on the dark
 * surface used for this theme.
 */
export function PrivacyConsentBannerStyles() {
  return (
    <style>{`
      [role="dialog"][aria-label="Privacy notice"],
      [role="dialog"][aria-labelledby="vibesites-privacy-panel-heading"] > div {
        --vibe-color-text: var(--vibe-color-text-on-primary, #ffffff);
        --vibe-color-text-muted: rgba(255, 255, 255, 0.85);
        --vibe-color-text-on-primary: #ffffff;
        --vibe-color-border: rgba(255, 255, 255, 0.35);
        color: var(--vibe-color-text-on-primary, #ffffff);
      }
      [role="dialog"][aria-label="Privacy notice"] a,
      [role="dialog"][aria-labelledby="vibesites-privacy-panel-heading"] a {
        color: var(--vibe-color-text-on-primary, #ffffff);
      }
    `}</style>
  );
}
